import { notifUtils } from "../components/NotifUtils/NotifUtils";
import { handleError } from "../components/Utils/Utils";
import VoucherService from "../Services/VoucherService";

export const getDetail = (store, value) => {
  store.setState({ isLoading: true, status: 200 });

  return VoucherService.getDetail(value)
    .then((response) => {
      const dataVoucher = response.data;
      const status = response.status;
      const header = response.headers;
      const isLoading = false;

      store.setState({ dataVoucher, status, header, isLoading });
    })
    .catch((error) => {
      handleError(error);
    });
};

export const getList = (store, value, refresh) => {
  store.setState({
    isLoading: true,
    status: 200,
    data: refresh ? [] : store.state.data,
  });

  return VoucherService.getList(value)
    .then((response) => {
      const status = response.status;
      const header = response.headers;
      let lastPage = false;
      const data = refresh
        ? response.data
        : store.state.data.concat(response.data);
      if (data.length < parseInt(value.num) || !header["x-cursor"]) {
        lastPage = true;
      } else if (value.num === "" || !value.num) {
        lastPage = true;
      } else if (
        header["x-cursor"] === store.state.header["x-cursor"] &&
        !refresh
      ) {
        lastPage = true;
      }

      const isLoading = false;
      store.setState({ status, header, lastPage, data, isLoading });
    })
    .catch((error) => {
      handleError(error);
    });
};

export const store = async (store, value) => {
  try {
    const response = await VoucherService.storeData(value);
    const data = response.data;
    notifUtils("Successfully Created Voucher", "success");
    return data;
  } catch (error) {
    handleError(error);
    return error;
  }
};

export const put = async (store, value, index) => {
  try {
    const response = await VoucherService.putData(index, value);
    const data = response.data;
    notifUtils("Successfully Updated Voucher", "success");
    return data;
  } catch (error) {
    handleError(error);
    return error;
  }
};

export const patch = async (store, value, index) => {
  try {
    const response = await VoucherService.patchData(index, value);
    const data = response.data;
    notifUtils("Successfully Updated Voucher", "success");
    return data;
  } catch (error) {
    handleError(error);
    return error;
  }
};

export const deleted = async (store, query) => {
  try {
    const response = await VoucherService.deleteData(query);
    const data = response.data;
    notifUtils("Successfully Deleted Voucher", "success");
    return data;
  } catch (error) {
    handleError(error);
    return false;
  }
};
